import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { UserSlice } from './features/UserSlice';
import { SurveySlice } from './features/CreateSurveySlice';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import CompleteSurveySlice, { SurveyResponseSlice } from './features/CompleteSurveySlice';

const rootReducer = combineReducers({
    user: UserSlice.reducer,
    survey: SurveySlice.reducer,
    response: SurveyResponseSlice.reducer,
});

const persistConfig = {
    key: 'root',
    storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: rootReducer,
});

export const useAppDispatch: () => typeof store.dispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<ReturnType<typeof store.getState>> = useSelector;

export const persistor = persistStore(store);
export default store;